import React, { useEffect, useMemo, useState } from "react";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Box,
} from "@mui/material";
import { FiChevronDown } from "react-icons/fi";

import UserLoginTable from "../../../components/Charts/UserLoginTable";
import CoverageTable from "../../../components/Tables/CoverageTable";
import RevenueTable from "../../../components/Tables/RevenueTable";
import UserKilometerTable from "../../../components/Charts/UserKilometerTable";
import UserVisitsTable from "../../../components/Charts/UserVisitsTable";

import FastAPIClient from "../../../client";
import config from "../../../config";
import BrandTable from "../../../components/Charts/BrandTable";
import LeadTable from "../../../components/Charts/LeadTable";
import ClientBrandProductTable from "../../../components/Charts/ClientBrandProductTable";
const client = new FastAPIClient(config);

interface User {
    user_id: string;
    first_name: string;
    last_name: string;
    team_name?: string | null;
    warehouse_name?: string | null;
    is_kilometers?: boolean | null;
}

const Analysis = () => {
    const [data, setData] = useState<User[]>([]);

    useEffect(() => {
        fetchActivity();
    }, []);

    const fetchActivity = async () => {
        try {
            const response = await client.fetchTeamMembers();
            console.log(response.results);
            setData(response.results);
        } catch (error) {
            console.error("Error fetching activity:", error);
        }
    };

    const hasKilometerUsers = useMemo(() => {
        return data.some((user) => user.is_kilometers === true);
    }, [data]);

    return (
        <div className="w-full flex flex-col items-center justify-center">
            <div className="w-full">
                <Typography
                    variant="subtitle1"
                    fontWeight={600}
                    sx={{
                        textAlign: "left",
                        width: "100%",
                        marginLeft: "15px",
                    }}
                >
                    Potentiel
                </Typography>
                <Accordion
                    sx={{
                        boxShadow: "none",

                        "&::before": { display: "none" },
                    }}
                >
                    <AccordionSummary expandIcon={<FiChevronDown />}>
                        <Typography variant="subtitle2">
                            Analyse détention client (DN) 2025 - par catégorie
                            produit (CA HTHD)
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <RevenueTable />
                    </AccordionDetails>
                </Accordion>

                <Accordion
                    sx={{
                        boxShadow: "none",

                        "&::before": { display: "none" },
                    }}
                >
                    <AccordionSummary expandIcon={<FiChevronDown />}>
                        <Typography variant="subtitle2">
                            Analyse détention client (DN) 2025 - par catégorie
                            produit, marque et produit (volume et CA HTHD)
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <ClientBrandProductTable />
                    </AccordionDetails>
                </Accordion>
                <Accordion
                    sx={{
                        boxShadow: "none",

                        "&::before": { display: "none" },
                    }}
                >
                    <AccordionSummary expandIcon={<FiChevronDown />}>
                        <Typography variant="subtitle2">
                            Analyse des marques 2024-2025 (volume et nombre de
                            clients)
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <BrandTable />
                    </AccordionDetails>
                </Accordion>
                <Accordion
                    sx={{
                        boxShadow: "none",

                        "&::before": { display: "none" },
                    }}
                >
                    <AccordionSummary expandIcon={<FiChevronDown />}>
                        <Typography variant="subtitle2">
                            Analyse des prospects (création, RDV, volume estimé)
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <LeadTable />
                    </AccordionDetails>
                </Accordion>
                <Typography
                    variant="subtitle1"
                    fontWeight={600}
                    sx={{
                        textAlign: "left",
                        width: "100%",
                        marginLeft: "15px",
                    }}
                >
                    Activité
                </Typography>

                <Accordion
                    sx={{
                        boxShadow: "none",

                        "&::before": { display: "none" },
                    }}
                >
                    <AccordionSummary expandIcon={<FiChevronDown />}>
                        <Typography variant="subtitle2">
                            Analyse de la couverture client par mois (fréquence
                            visite paramétrée et nombre de visites réalisées par
                            client)
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <CoverageTable />
                    </AccordionDetails>
                </Accordion>

                {hasKilometerUsers && (
                    <Accordion
                        sx={{
                            boxShadow: "none",

                            "&::before": { display: "none" },
                        }}
                    >
                        <AccordionSummary expandIcon={<FiChevronDown />}>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100%",
                                }}
                            >
                                <Typography variant="subtitle2">
                                    Suivi du kilométrage par commercial par jour
                                    (basé sur les saisies km)
                                </Typography>
                            </Box>
                        </AccordionSummary>

                        <AccordionDetails>
                            <UserKilometerTable />
                        </AccordionDetails>
                    </Accordion>
                )}
                <Accordion
                    sx={{
                        boxShadow: "none",

                        "&::before": { display: "none" },
                    }}
                >
                    <AccordionSummary expandIcon={<FiChevronDown />}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                            }}
                        >
                            <Typography variant="subtitle2">
                                Suivi des visites par commerical par jour (basé
                                sur les comptes-rendus)
                            </Typography>
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <UserVisitsTable />
                    </AccordionDetails>
                </Accordion>
                <Accordion
                    sx={{
                        boxShadow: "none",

                        "&::before": { display: "none" },
                    }}
                >
                    <AccordionSummary expandIcon={<FiChevronDown />}>
                        <Typography variant="subtitle2">
                            Suivi du nombre de connexions par commercial depuis
                            le 7 Avril 2025
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <UserLoginTable />
                    </AccordionDetails>
                </Accordion>
            </div>
        </div>
    );
};

export default Analysis;
